import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Modify")
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "d-f my-16" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex-1 f-bold" }, "Entry Price", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_QuoteBar = _resolveComponent("QuoteBar")
  const _component_TheStopLoss = _resolveComponent("TheStopLoss")
  const _component_TheTakeProfit = _resolveComponent("TheTakeProfit")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, {
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "symbol_34" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    confirm: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "flex-1 primary",
        onClick: _ctx.saveEdit,
        progress: _ctx.progress
      }, {
        default: _withCtx(() => [
          _createVNode(_component_t, {
            path: "symbol_38",
            custom: ""
          }, {
            default: _withCtx(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Submit'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "progress"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_QuoteBar, {
          symbol: _ctx.symbol,
          class: "bg-white pt-12"
        }, null, 8, ["symbol"]),
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.position.createPrice), 1)
        ]),
        _createVNode(_component_TheStopLoss, {
          "show-distance": "",
          symbol: _ctx.symbol,
          createPrice: _ctx.position.createPrice
        }, null, 8, ["symbol", "createPrice"]),
        _createVNode(_component_TheTakeProfit, {
          "show-distance": "",
          symbol: _ctx.symbol,
          createPrice: _ctx.position.createPrice
        }, null, 8, ["symbol", "createPrice"])
      ])
    ]),
    _: 1
  }))
}